<template>
    <div>
        <el-card class="box-card">
            <el-form label-width="70px" @submit.native.prevent size="small">
                <el-form-item label="链接地址">
                    <el-input
                        type="textarea"
                        :rows="10"
                        placeholder="链接地址"
                        v-model="formModel.content" resize="none" show-word-limit>
                    </el-input>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input
                        placeholder="请输入密码"
                        v-model="formModel.password">
                    </el-input>
                </el-form-item>
                <el-row>
                    <el-form-item>
                        <el-button-group>
                            <el-button icon="el-icon-s-promotion" @click="handleParse('cloudreve')">Cloudreve
                            </el-button>
                            <el-button icon="el-icon-link" @click="handleOpenUrl(`https://cloud.yuntao.xyz`)">Go
                            </el-button>
                        </el-button-group>
                        <el-divider direction="vertical"></el-divider>

                        <!--                        <el-button-group>
                                                    <el-button icon="el-icon-s-promotion" @click="handleParse('easychuan')">Easychuan</el-button>
                                                    <el-button icon="el-icon-link"  @click="handleOpenUrl(`https://easychuan.cn/`)" >Go</el-button>
                                                </el-button-group>
                                                <el-divider direction="vertical"></el-divider>-->


                        <el-button-group>
                            <el-button icon="el-icon-s-promotion" @click="handleParse('cloudpaste')">CloudPaste
                            </el-button>
                            <el-button icon="el-icon-link" @click="handleOpenUrl(`https://paste.yuntao.xyz/`)">Go
                            </el-button>
                        </el-button-group>
                        <el-divider direction="vertical"></el-divider>
                        <el-button-group>
                            <el-button icon="el-icon-s-promotion" @click="handleParse('lanzou')">蓝奏云</el-button>
                            <el-button icon="el-icon-link" @click="handleOpenUrl(`https://up.woozooo.com/`)">Go
                            </el-button>
                        </el-button-group>
                        <el-divider direction="vertical"></el-divider>
                        <!--                        <el-button-group>
                                                    <el-button icon="el-icon-s-promotion" @click="handleParse('nainiu')">奶牛快传</el-button>
                                                    <el-button icon="el-icon-link"  @click="handleOpenUrl(`https://cowtransfer.com/`)" >Go</el-button>
                                                </el-button-group>
                                                <el-divider direction="vertical"></el-divider>-->
                        <el-button @click="handleClear">清空</el-button>
                    </el-form-item>
                </el-row>

            </el-form>
        </el-card>
        <div style="height: 10px"></div>
        <el-card class="box-card code-container" :body-style="{ paddingBottom: '0px' }">
            <el-form label-width="70px" @submit.native.prevent size="small">

                <el-form-item label="结果">
                    <!--                    element-loading-text="拼命解析中"
                                        element-loading-spinner="el-icon-loading"
                                        element-loading-background="rgba(0, 0, 0, 0.8)"-->
                    <el-input
                        v-loading="loading"
                        type="textarea"
                        :rows="12"
                        placeholder="结果"
                        v-model="formModel.result" resize="none" show-word-limit>
                    </el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-link type="primary" @click="handleCopyWget($event)"
                             :disabled="$strings.isBlank(formModel.result)">wget下载
                    </el-link>
                    <el-divider direction="vertical"></el-divider>
                    <el-link type="primary" @click="handleCopyCurl($event)"
                             :disabled="$strings.isBlank(formModel.result)">curl下载
                    </el-link>
                </el-form-item>
            </el-form>


        </el-card>
    </div>
</template>

<script>


export default {
    name: "NetdiskParse",
    components: {},
    data() {
        return {
            formModel: {
                generateMode: 'batch',
                codeType: 'qrcode',
                content: '',
                height: 200,
                spaceWidth: 20
            },
            codeValues: [],
            loading: false,

            refererMap: {
                'nainiu': `https://cowtransfer.com/`
            },
            referer: null // 部分网盘有防盗链
        }
    },
    computed: {
        cpCodeWrapperStyle() {
            let {spaceWidth} = this.formModel
            return {
                'display': 'inline-block',
                'margin-right': spaceWidth + 'px'
            }
        }
    },
    methods: {
        handleCopyWget(e) {
            /*-U '${ua}'*/
            // url 需要加单引号，原因是 URL 里面包含特殊字符 比如 &，导致 URL 被截断，造成请求 URL 不完整
            let ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/72.0.3626.121 Safari/537.36'
            let command = `wget ${this.referer ? `--referer='${this.referer}'` : ''} --content-disposition   '${this.formModel.result}'`

            this.$clipboard(command, e)
        },
        handleCopyCurl(e) {
            /* -A '${ua}'*/
            let ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/72.0.3626.121 Safari/537.36'
            let command = `curl ${this.referer ? `-e '${this.referer}'` : ''} -J -O   '${this.formModel.result}'`

            this.$clipboard(command, e)
        },
        handleParse(wpName) {
            let {content, password} = this.formModel

            if (this.$strings.isBlank(content)) {
                return
            }

            this.loading = true

            let referer = this.refererMap[wpName]
            this.referer = referer


            this.$set(this.formModel, 'result', '')

            this.$http.post('/clouddrive/parse', {
                url: content,
                password,
                type: wpName
            }).then(result => {
                if (result.success) {
                    this.$set(this.formModel, 'result', result.data)
                } else {
                    this.$message.error(result.message)
                }
            }).catch(({message}) => {
                this.$message.error(message)
            }).finally(() => {
                this.loading = false
            })
        },

        nainiuParse() {
            let {content, password} = this.formModel


            return new Promise((resolve, reject) => {
                // 支持分项连接替换  https://cowtransfer.com/s/578c9c040eea4d
                let reg = /(http[s]*):\/\/(.*?)(\/s\/)(.*)/ig

                let arr = reg.exec(content)
                if (arr == null || arr.length != 5) {
                    return reject({message: '请确认链接是否正确'})
                }
                let pickCode = arr[4]

                let url = `https://tools.yuntao.xyz/api/nainiu/core/api/transfer/share?uniqueUrl=${pickCode}`
                this.$http.get(url).then(resp => {
                    let {message, data} = resp

                    if (message != 'success') {
                        return reject({message: '请确认是否已上传文件'})
                    }
                    // 有多个文件时，取第一个
                    let {guid, transferName, firstFile: {id}} = data


                    url = `https://tools.yuntao.xyz/api/nainiu/core/api/transfer/share/download/links?transferGuid=${guid}&title=${encodeURI(transferName)}&fileId=${id}`
                    // let data = {code: pickCode, filekey, use_https: true}
                    this.$http.get(url, data).then(resp => {
                        if (resp.message != 'success') {
                            return reject({message: resp.message})
                        }
                        resolve(resp.data[0])
                    })
                })
            })
        },
        easychuanParse() {
            let {content, password} = this.formModel


            return new Promise((resolve, reject) => {
                // 支持分项连接替换  https://easychuan.cn/r/2yjzb?t=ff
                let reg = /(http[s]*):\/\/(.*?)(\/r\/)(.*?)\?/ig
                /*if (!reg.test(content)) {
                    this.$message.warning('请确认链接是否正确 1')
                    return
                }*/
                let arr = reg.exec(content)
                if (arr == null || arr.length != 5) {
                    return reject({message: '请确认链接是否正确'})
                }
                let pickCode = arr[4]

                let url = `https://tools.yuntao.xyz/api/easychuan/files/${pickCode}`
                this.$http.get(url).then(resp => {
                    let {files = []} = resp

                    if (files.length == 0) {
                        return reject({message: '请确认是否已上传文件'})
                    }
                    // 有多个文件时，取第一个
                    let {filekey, filename, filesize} = files[0]

                    url = 'https://tools.yuntao.xyz/api/easychuan/files/link'
                    let data = {code: pickCode, filekey, use_https: true}
                    this.$http.post(url, data).then(resp => {
                        resolve(resp.url)
                    })
                })
            })
        },

        handleOpenUrl(url) {
            window.open(url, '_blank')
        },
        handleClear() {
            this.$set(this.formModel, 'content', '')
            this.$set(this.formModel, 'result', '')
        }
    }
}
</script>

<style scoped>

.code-container {
    width: 100%;
    /*height: 40vh;*/
    overflow-y: auto;
}

.code-wrapper {
    display: inline-block;
    margin-right: 10px
}

.el-radio {
    margin-right: 10px;
}
</style>
